import Head from 'next/head';
import { Fragment, useEffect } from 'react';
import { FilterProps } from '@/graphQl/nftList.type';
import { useWallet } from '@/lib';
import { useNftContent } from '@/lib/providers/NftContextProvider';
import { useContent } from '@/provider/ContentProvider';
import { useMenuDetails } from '@/provider/MenuContext';
import HomeLayout from '../layouts/HomeLayout';
import withAuth from '@/lib/components/AuthSessionValidate';
import { useQuery } from '@tanstack/react-query';

const Home = () => {
  const { content } = useContent();
  const { setMenuIndex } = useMenuDetails();
  const { address } = useWallet();
  const {
    totalNfts,
    totalSold,
    soldItems,
    nftFilter: { isSaleStarted, isSaleEnded },
    setNftFilter,
    refetchSoldTokens,
    isCountLoading,
    soldItemsIsLoading,
    fetchSoldItemsCount
  } = useNftContent();

  //Reset filter on menu
  useEffect(() => {
    if (address) {
      setMenuIndex(0);
    }
  }, [address, setMenuIndex]);

  //Reset filter on initial load
  useEffect(() => {
    setNftFilter((prev) => ({
      ...prev,
      filter: FilterProps.ALL
    }));
  }, [setNftFilter]);

  useQuery({
    queryKey: ['sold_items_count_refetch'],
    queryFn: async () => {
      await refetchSoldTokens();

      return null;
    }
  });

  useQuery({
    queryKey: ['sold_items_count_count'],
    queryFn: async () => {
      await fetchSoldItemsCount();

      return null;
    }
  });

  return (
    <Fragment>
      <Head>
        {/* HTML Meta Tags */}
        <title>Kinetek | Source Data - Generative Art & NFTs</title>
        <meta
          name="description"
          content="Explore 'Source Data' at Kinetek, featuring generative AI, photography, and audiovisual works. Buy NFTs with ETH."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>

      <HomeLayout
        isSaleStarted={isSaleStarted ?? true}
        isSaleEnded={isSaleEnded}
        heroBlock={content.hero}
        tokenDetails={{
          soldCount: totalSold ?? 0,
          isLoading: soldItemsIsLoading || isCountLoading,
          tokensUsed: totalSold ?? 80,
          totalTokens: totalNfts ?? 80
        }}
        soldItems={soldItems}
        stadiumBlock={content.stadium}
      />
    </Fragment>
  );
};

export default withAuth(Home);
